module.exports = __webpack_public_path__ + "static/img/icons-close.c44e832b.svg";